export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7278.d563c077.jpg";